import { createTrackingUtils } from "../index.js";
const utils = createTrackingUtils({
    name: "flights_apex_web_delta_airlines_pilot_2026",
    defaultStage: 1,
    stages: {},
    goals: {
        delta_offer_seen: 2,
        dl_offer_flight_details: 3,
        empty_delta_fares_seen: 4,
        dl_offer_checkout_start: 5
    },
    goalsWithValue: ["flights_delta_fares_loader_seen_ms"]
});
export default utils;
